import { dateHandler } from './date-utils';

export const normalizeRawTransaction = (transaction) => {
    return {
        id: transaction.id,
        title: transaction.title,
        description: transaction.description,
        amount: parseFloat(transaction.amount).toFixed(2),
        category: transaction.category,
        subcategory: transaction.subcategory,
        account: transaction.account,
        startDate: transaction.start_date,
        endDate: transaction.end_date,
        isRecurring: parseInt(transaction.is_recurring),
        recurringType: transaction.recurring_type,
        dayOfWeek: transaction.day_of_week !== null ? parseInt(transaction.day_of_week) : '',
        dayOfMonthList: transaction.day_of_month_list !== null ? transaction.day_of_month_list.split(',').map(Number) : '',
        weekOfMonth: transaction.week_of_month,
        monthOfYear: transaction.month_of_year !== null ? parseInt(transaction.month_of_year) : '',
        separationCount: transaction.separation_count !== null ? parseInt(transaction.separation_count) : 1,
        isSnowball: parseInt(transaction.is_snowball),
    }
}

export const normalizeTransactionFormData = (transaction) => {
    return {
        id: transaction.id,
        title: transaction.title,
        description: transaction.description,
        amount: parseFloat(transaction.amount).toFixed(2),
        category: transaction.category,
        subcategory: transaction.subcategory,
        account: transaction.account,
        startDate: dateHandler.toSubmitFormat(transaction.startDate, 'normalizeTransactionFormData startDate'),
        endDate: transaction.endDate
            ? dateHandler.toSubmitFormat(transaction.endDate, 'normalizeTransactionFormData endDate')
            : null,
        isRecurring: transaction.isRecurring,
        recurringType: transaction.recurringType,
        dayOfWeek: parseInt(transaction.dayOfWeek) ?? null,
        dayOfMonthList: transaction.dayOfMonthList ?? null,
        weekOfMonth: transaction.weekOfMonth,
        monthOfYear: parseInt(transaction.monthOfYear) ?? null,
        separationCount: transaction.separationCount
            ? parseInt(transaction.separationCount)
            : 1,
        isSnowball: transaction.isSnowball,
    }
}

export const normalizeRawException = (exception) => {
    return {
        id: exception.id,
        transactionId: exception.transaction_id,
        isRescheduled: exception.is_rescheduled,
        isCancelled: exception.is_cancelled,
        startDate: exception.start_date,
        endDate: exception.end_date,
        amount: parseFloat(exception.amount).toFixed(2),
        instanceDate: exception.instanceDate,
        daysAdjusted: exception.days_adjusted,
        isPaid: exception.is_paid,
        highlight: exception.highlight,
    }
}

export const normalizeExceptionFormData = (exception) => {
    return {
        id: exception?.id,
        transactionId: exception.transactionId,
        instanceDate: dateHandler.toSubmitFormat(exception.instanceDate),
        startDate: dateHandler.toSubmitFormat(exception.startDate),
        endDate: dateHandler.toSubmitFormat(exception.endDate),
        amount: exception.amount,
        isRescheduled: exception.isRescheduled ? 1 : 0,
        isCancelled: exception.isCancelled ? 1 : 0,
        isPaid: exception.isPaid ? 1 : 0,
        highlight: exception.highlight ? 1 : 0,
        daysAdjusted: exception.daysAdjusted,
    }
}

export const normalizeRawTransactionTemplate = (template) => {
    return {
        id: template.id,
        title: template.title,
        description: template.description,
        amount: parseFloat(template.amount).toFixed(2),
        category: template.category,
        subcategory: template.subcategory,
        account: template.account,
        startDate: template.start_date,
        endDate: template.end_date,
        isRecurring: template.is_recurring,
        recurringType: template.recurring_type,
        dayOfWeek: template.day_of_week,
        dayOfMonthList: template.day_of_month_list,
        weekOfMonth: template.week_of_month,
        monthOfYear: template.month_of_year,
        separationCount: template.separation_count,
        isSnowball: template.is_snowball,
        templateName: template.template_name,
    }
}

export const normalizeTransactionTemplateFormDataToFieldNames = (template) => {
    return {
        id: template.id,
        title: template.title,
        description: template.description,
        amount: parseFloat(template.amount).toFixed(2),
        category: template.category,
        subcategory: template.subcategory,
        account: template.account,
        start_date: dateHandler.toInputFormat(template.startDate),
        end_date: template.endDate
            ? dateHandler.toInputFormat(template.endDate)
            : null,
        is_recurring: template.isRecurring,
        recurring_type: template.recurringType,
        day_of_week: template.dayOfWeek,
        day_of_month_list: template.dayOfMonthList,
        week_of_month: template.weekOfMonth,
        month_of_year: template.monthOfYear,
        separation_count: template.separationCount,
        is_snowball: template.isSnowball,
        template_name: template.templateName,
    }
}
